import {
  VERIFY_MANUAL_TRANSACTION,
  QR_INIT_MANUAL,
  QR_MANUAL_CHECK,
} from "../constants/transaction";

// =====================VERIFY manual transation  ================
const getManualTransactionInitialState = {
  isLoading: false,
  data: "",
  error: "",
};

export const getVerifyManualTransactionReducer = (
  state = getManualTransactionInitialState,
  action
) => {
  switch (action.type) {
    case VERIFY_MANUAL_TRANSACTION.LOADING:
      return {
        ...state,
        isLoading: action.payLoad,
      };
    case VERIFY_MANUAL_TRANSACTION.SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        isLoading: false,
        error: null,
      };
    case VERIFY_MANUAL_TRANSACTION.ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payLoad,
      };
    default:
      return state;
  }
};

// =====================QR manual transation  ================
const postQrInitManualInitialState = {
  isLoading: false,
  data: "",
  error: "",
};

export const postQrInitManualReducer = (
  state = postQrInitManualInitialState,
  action
) => {
  switch (action.type) {
    case QR_INIT_MANUAL.LOADING:
      return {
        ...state,
        isLoading: action.payLoad,
      };
    case QR_INIT_MANUAL.SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        isLoading: false,
        error: null,
      };
    case QR_INIT_MANUAL.ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payLoad,
      };
    default:
      return state;
  }
};

// =====================QR manual Check  ================
const getQrManualCheckInitialState = {
  isLoading: false,
  data: "",
  error: "",
};

export const getQrManualCheckReducer = (
  state = getQrManualCheckInitialState,
  action
) => {
  switch (action.type) {
    case QR_MANUAL_CHECK.LOADING:
      return {
        ...state,
        isLoading: action.payLoad,
      };
    case QR_MANUAL_CHECK.SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        isLoading: false,
        error: null,
      };
    case QR_MANUAL_CHECK.ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payLoad,
      };
    default:
      return state;
  }
};
